import React from "react";

function Footer(){
    return <div className="fixed bottom-0 md:w-7/12 md:h-24  text-white text-xl font-medium  ">
        <div className="md:p-4 border-2 rounded-xl   border-b-0 border-green-500 bg-black ">
            <ul className=" flex gap-20 md:p-4 justify-evenly">
            <a href="/">
                <li className="hover:border-b-2 invisible md:visible  hover:border-green-300 ">
                About Me
                </li></a>
            <a href="/about">
                <li className="hover:border-b-2 invisible md:visible  hover:border-green-300 ">
                        Tech I Use
                </li></a>
                <a href="/pro">
                <li className="hover:border-b-2 invisible md:visible  hover:border-green-300 ">
                    My Projects
                </li></a>
                
                
            </ul>
            <ul className=" flex justify-evenly">
            <a href="/">
                <li className=" visible md:invisible pb-10  ">
                <img className="rounded-full h-10 w-10 " src="./resources/information.png" alt="head"/>
                </li></a>
            <a href="/about">
                <li className=" visible md:invisible   ">
                <img className="rounded-full h-10 w-10 " src="./resources/robotic-hand.png" alt="head"/>
                </li></a>
                <a href="/pro">
                <li className=" visible md:invisible   ">
                <img className="rounded-full h-10 w-10 " src="./resources/cont.png" alt="head"/>
                </li></a>
                
            </ul>
        </div>
    </div>
}

export default Footer;